import { useSearchParams } from "react-router-dom";
import { AppConfigWizard } from "@/components/applications/config/AppConfigWizard";
import { useAllAppConfigs } from "@/hooks/useAppConfigurations";
import { useApplications } from "@/hooks/useApplications";

export default function NewAppConfigPage() {
  const [params] = useSearchParams();
  const duplicateId = params.get("duplicate");
  const { data: configs = [], isLoading } = useAllAppConfigs();
  const { applications } = useApplications();

  if (duplicateId && isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  const source = duplicateId
    ? configs.find((c) => c.policyId === duplicateId)
    : undefined;

  // For duplicate flow, prefer to resolve the catalog app so the wizard
  // arrives on the keys step with a known target rather than asking the user
  // to re-pick.
  const catalogApp = source
    ? applications.find((a) => a.bundleId === source.bundleId)
    : undefined;

  return (
    <AppConfigWizard
      initial={
        source
          ? {
              target: {
                mode: catalogApp ? "catalog" : "external",
                catalogAppId: catalogApp?.id,
                appName: catalogApp?.name ?? source.bundleId,
                bundleId: source.bundleId,
              },
              configName: `${source.configName} (copy)`,
              keys: source.keys,
            }
          : undefined
      }
    />
  );
}
